/** Resolve campaign id used by leads form API (assignment list may use proposal_id or id). */
export function getCampaignProposalId(campaign) {
  if (!campaign) return null;
  return campaign.proposal_id ?? campaign.id ?? null;
}

export function filterEnabledCampaigns(campaigns = []) {
  return campaigns.filter((campaign) => campaign?.is_disabled === false);
}

/** Normalize getFormsByCampaignId response into a flat form array. */
export function normalizeLeadFormsList(response) {
  if (!response || response.status !== 200) return [];

  const payload = response.data;

  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.forms)) return payload.forms;

  if (payload && typeof payload === 'object') {
    const values = Object.values(payload);
    if (values.length === 1 && Array.isArray(values[0])) return values[0];
    return values.filter(
      (item) => item && typeof item === 'object' && (item.leads_form_id || item.leads_form_name)
    );
  }

  return [];
}
